import summaryTemplate from './summary.html';

export default angular
  .module('main.devices.edit.tabs.summary', [])

  .directive('editDeviceSummaryTab', () => {
    return {
      restrict: 'E',
      template: summaryTemplate,
      scope: {},
      controller: ($q,
                   $scope,
                   $rootScope,
                   $filter,
                   $interval,
                   EditDeviceDataProvider,
                   PermissionsService,
                   CloudConfigService,
                   ToastsService,
                   utils) => {
        const $t = $filter('translate');
        const AVAILABLE_CLOUDS_LOCAL_STORAGE_KEY = 'App-Clouds';
        const MAIN_CLOUD_LOCAL_STORAGE_KEY = 'Main-Cloud';

        // Reload device data interval
        const DEVICE_UPDATE_INTERVAL = 10000;
        let reloadDeviceInterval;

        $scope.dataProvider = EditDeviceDataProvider.instance;
        $scope.timeFormatStr = $t('datetime.mdyHM12');

        angular.extend($scope, {
          goToEditProxy: goToEditProxy,
          showProxyTags: showProxyTags,
          canEditDevice: canEditDevice,
          startPairing: startPairing,
          startHardwareReboot: startHardwareReboot,
          copyToClipboard: $rootScope.copyToClipboard,
          openChangeCloudModal: openChangeCloudModal,
          changeCloud: changeCloud,
          assignDeviceUser: assignDeviceUser,
        });

        init();

        function init() {
          $scope.loading = true;
          $q.all([
            $scope.dataProvider.deviceResource.init(),
            $scope.dataProvider.deviceProxyResource.init(),
            $scope.dataProvider.deviceZoneResource.init(),
            $scope.dataProvider.isGatewayResource.init(),
            $scope.dataProvider.deviceBatteryStatusResource.init(),
            $scope.dataProvider.devicePowerStatusResource.init(),
            $scope.dataProvider.canPairDeviceResource.init(),
            $scope.dataProvider.canHardwareRebootResource.init(),
            $scope.dataProvider.deviceNetworkResource.init(),
            $scope.dataProvider.canChangeCloudResource.init(),
            $scope.dataProvider.deviceUserMappingResource.init(),
            $scope.dataProvider.alwaysConnectedResource.init(),
            $scope.dataProvider.isDeviceInPairingModeResource.init(),
          ])
            .then(() => {
              $scope.loading = false;
              initViewModel();
              initWatchers();
            }, (err) => {
              // utils.handleApiError(err);
              $scope.loading = false;
            });

          $scope.$on('$destroy', () => {
            // The data provider is shared across tabs.
            stopDeviceRefresh();
            $('#reboot-device-dialog').remove();
            $('#change-cloud-modal').remove();
            $('#assign-user-modal').remove();
          });
        }

        function initWatchers() {
          // Reload devices when switching to 'devices' tab
          $scope.$watch('dataProvider.activeTab', (newVal, oldVal) => {
            if (newVal === 'summary') {
              startDeviceRefresh();
            } else if (oldVal === 'summary') {
              stopDeviceRefresh();
            }
          });
        }

        function initViewModel() {
          // Ignore device connection status
          $scope.alwaysConnected = angular.copy($scope.dataProvider.alwaysConnectedResource.value);
          if ($scope.alwaysConnected) {
            $scope.dataProvider.deviceResource.value.connected = true;
            $scope.dataProvider.isDeviceConnected = true;
          }

          $scope.device = angular.copy($scope.dataProvider.deviceResource.value);
          // A device references either a gateway (proxyId) or a zone (zoneId), never both.
          // Reuse a single `deviceProxy` view-model for whichever one exists.
          $scope.deviceProxy = angular.copy($scope.dataProvider.deviceProxyResource.value
            || $scope.dataProvider.deviceZoneResource.value);
          // The reference is a zone when there's no gateway proxy but a zone parent exists.
          $scope.isZone = !$scope.dataProvider.deviceProxyResource.value
            && !!$scope.dataProvider.deviceZoneResource.value;
          $scope.isGateway = angular.copy($scope.dataProvider.isGatewayResource.value);
          $scope.isNetworkConnections = !!$scope.dataProvider.deviceNetworkResource.value;
          $scope.userMapping = angular.copy($scope.dataProvider.deviceUserMappingResource.value);
          $scope.locationUsers = [];

          $scope.lastConnectedDateFormatted = $filter('date')(new Date($scope.device.lastDataReceivedDateMs), 'medium');

          getAvailableClouds();
          checkMappedUsers();
        }

        /**
         * Reload device data
         */
        function startDeviceRefresh() {
          if (reloadDeviceInterval) {
            $interval.cancel(reloadDeviceInterval);
          }

          reloadDeviceInterval = $interval(() => {
            $q.all([
              $scope.dataProvider.deviceInfoResource.init(true),
              $scope.dataProvider.deviceResource.init(true),
            ]).then(() => initViewModel());
          }, DEVICE_UPDATE_INTERVAL);
        }

        function stopDeviceRefresh() {
          if (reloadDeviceInterval) {
            $interval.cancel(reloadDeviceInterval);
          }
        }

        function canEditDevice(device) {
          return PermissionsService.canIEditDevice(device);
        }

        function goToEditProxy(tabName) {
          if ($scope.loading || !$scope.deviceProxy || !canEditDevice($scope.deviceProxy)) {
            return;
          }
          $scope.dataProvider.goToDevice($scope.deviceProxy, tabName);
        }

        function showProxyTags() {
          goToEditProxy();
        }

        function startPairing() {
          if ($scope.loading ||
            !$scope.dataProvider.isDeviceConnected ||
            $scope.dataProvider.isDeviceRebooting ||
            $scope.dataProvider.isDeviceInPairingModeResource.value ||
            $scope.dataProvider.isDeviceInForcedPairingMode) {
            return;
          }
          $scope.dataProvider.startPairingMode();
        }

        function getAvailableClouds() {
          if (!$scope.dataProvider.canChangeCloudResource.value) {
            return;
          }

          let currentCloud = utils.getStorageItem(MAIN_CLOUD_LOCAL_STORAGE_KEY);
          let availableClouds = utils.getStorageItem(AVAILABLE_CLOUDS_LOCAL_STORAGE_KEY) || [];
          $scope.availableClouds = availableClouds.filter(el => el.name !== currentCloud.name);
          $scope.selectedCloudName = ($scope.availableClouds && $scope.availableClouds.length > 0) && $scope.availableClouds[0].name;

          if (!$scope.availableClouds.length) {
            CloudConfigService.getClouds()
              .then(clouds => {
                // Save clouds list for future
                utils.setStorageItem(AVAILABLE_CLOUDS_LOCAL_STORAGE_KEY, clouds);
                $scope.availableClouds = clouds.filter(el => el.name !== currentCloud.name);
                $scope.selectedCloudName = ($scope.availableClouds && $scope.availableClouds.length > 0) && $scope.availableClouds[0].name;
              })
              .catch(err => angular.log(err));
          }
        }

        /**
         * Mapping location user to personal device per device model
         * attribute "userMapping" and user ID linked to device.
         */
        function checkMappedUsers() {
          if (!$scope.userMapping || !$scope.userMapping.show) {
            return;
          }

          // Get location users
          $scope.dataProvider.locationUsersResource.init()
            .then((data) => {
              let result = data.map(el => {
                let result = el.firstName || el.lastName ? el.firstName + ' ' + el.lastName : $t('common.unknownUser');
                if (el.role) {
                  result = result + ' (' + $t('users.locationUserRole.' + el.role) + ')';
                }

                el.name = result;
                return el;
              });

              $scope.locationUsers = angular.copy(result);
              $scope.assignedUser = $scope.locationUsers.find(el => el.id === $scope.device.userId);
              $scope.assignedUserId = $scope.assignedUser && $scope.assignedUser.id;
              $scope.availableLocationUsers = $scope.locationUsers.filter(el => el.id !== $scope.device.userId);
            });
        }

        /**
         * Assign user modal.
         */
        function assignDeviceUser() {
          if ($scope.loading) {
            return;
          }

          $('#assign-user-modal').modal({
            autofocus: false,
            onApprove: () => {
              $scope.$applyAsync(() => {
                $scope.loading = true;

                const userId = $scope.assignedUserObject ? $scope.assignedUserObject.id : 0;
                $scope.dataProvider.saveDeviceInfo(void 0, void 0, userId)
                  .then(() => {
                    $scope.assignedUser = $scope.locationUsers.find(el => el.id === userId);
                    $scope.assignedUserId = $scope.assignedUser && $scope.assignedUser.id;
                    $scope.availableLocationUsers = $scope.locationUsers.filter(el => el.id !== $scope.assignedUserId);

                    ToastsService.success();
                    $scope.loading = false;
                  }, (err) => {
                    utils.handleApiError(err);
                    $scope.loading = false;
                  });
              });
            },
          }).modal('show');
        }

        /**
         * Open confirmation for hardwarre reboot.
         * */
        function startHardwareReboot() {
          if ($scope.loading) {
            return;
          }

          $('#reboot-device-dialog')
            .modal({
              autofocus: false,
              closable: true,
              detachable: true,
              onApprove: function() {
                $scope.dataProvider.rebootDevice();
              }
            })
            .modal('show');
        }

        /** Open change cloud modal */
        function openChangeCloudModal() {
          if ($scope.loading) {
            return;
          }

          $('#change-cloud-modal').modal({
            autofocus: false
          }).modal('show');
        }

        function changeCloud() {
          $scope.loading = true;

          let selectedCloud = $scope.selectedCloud.servers.find(el => el.type === 'appapi');
          if (!selectedCloud || !selectedCloud.host) {
            return;
          }

          $scope.dataProvider.changeCloud(selectedCloud.host)
            .then(() => {
              ToastsService.success(null, $t('devices.info.cloud.success'));
              $scope.dataProvider.goBack();
            }, (err) => {
              utils.handleApiError(err);
              $scope.loading = false;
            });
        }
      }
    };
  })
  .name;
